import { roundToTwoDecimals } from "../../../helper_functions/utils";
import type { PaymentDueDateStatus, PaymentStatus } from "../../../api_utils/types";

export function paymentStatuses(
  amountPaid: string | null,
  paymentDueDate: string | null,
  total: number,
): {
  paymentStatus: PaymentStatus;
  paymentDueDateStatus: PaymentDueDateStatus | null;
} {
  const amountRemaining = roundToTwoDecimals(total) - Number(amountPaid);
  const paymentStatus = amountRemaining <= 0 ? "Paid" : Number(amountPaid) > 0 ? "Partially paid" : "Unpaid";
  const [today] = new Date().toISOString().split("T");
  const paymentDueDateStatus = paymentDueDate
    ? paymentDueDate < today && amountRemaining > 0
      ? "Overdue"
      : "Not overdue"
    : null;

  return { paymentStatus, paymentDueDateStatus };
}
